<template>
    <div class="mainBox">
        <div class="main-header">
            <el-row :gutter="10">
                <el-col :span="24">
                    <el-button type="primary" icon='el-icon-plus' size="medium" @click='handleInsert'>新增菜单</el-button>
                    <el-button icon='el-icon-refresh' size="medium" @click='init'>刷新</el-button>
                </el-col>
            </el-row>
        </div>
        <div class="main-content">
            <el-table
                :data="mainLists"
                row-key="id"
                border
                stripe
                class="common-tree-table"
                header-row-class-name='header_row_style'>
                <el-table-column
                    prop="title"
                    label="菜单名称"
                    min-width="120px">
                </el-table-column>
                <el-table-column
                    prop="code"
                    label="菜单类型"
                    min-width="120px">
                </el-table-column>
                <el-table-column
                    prop="url"
                    label="菜单路径"
                    min-width="120px">
                </el-table-column>
                <el-table-column
                    prop="sort"
                    label="菜单排序"
                    min-width="100px">
                </el-table-column>
                <el-table-column
                    prop="status"
                    label="状态"
                    align="center"
                    min-width="120px">
                    <template slot-scope="scope">
                        <el-switch
                            v-model="scope.row.status"
                            active-color="#409EFF"
                            active-value="active"
                            inactive-value="unactive"
                            disabled>
                        </el-switch>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="operation"
                    label="操作"
                    min-width="300px"
                    align="center">
                    <template slot-scope="scope">
                        <el-button
                            type="success"
                            size="mini"
                            icon="el-icon-plus"
                            @click.stop="handleInsert(scope.row)">
                            添加子菜单
                        </el-button>
                        <el-button
                            type="primary"
                            size="mini"
                            icon="el-icon-edit-outline"
                            @click.stop="handleEdit(scope.row)">
                            编辑
                        </el-button>
                        <el-button
                            type="danger"
                            size="mini"
                            icon="el-icon-delete"
                            @click="handleDelete(scope.row)">
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- 添加菜单 -->
        <el-dialog title="菜单管理" :visible.sync="showMenuDialogVisible" @close='handleReset' width="600px" :close-on-click-modal='false'>
            <el-form ref="menuForm" :model="menuForm" :rules='formItemRules' label-width="100px" size="medium">
                <el-form-item prop="type" label="侧边栏类型" v-if='menuForm.pid != "0"'>
                    <el-select v-model="menuForm.type" placeholder="请选择侧边栏类型" clearable>
                        <el-option label="文本" value="1"></el-option>
                        <el-option label="链接" value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item prop='title' label='菜单名称'>
                    <el-input  v-model="menuForm.title" placeholder='请输入菜单名称' clearable></el-input>
                </el-form-item>
                <el-form-item prop='code' label='菜单类型'>
                    <el-input  v-model="menuForm.code" placeholder='请输入菜单类型' clearable></el-input>
                </el-form-item>
                <template  v-if='menuForm.pid != "0" && showMenuDialogVisible'>
                    <el-form-item prop='url' label='菜单路径' v-if='menuForm.type == "2"'>
                        <el-input  v-model="menuForm.url" placeholder='请输入菜单路径' clearable></el-input>
                    </el-form-item>
                    <el-form-item prop='pid' label='父节点'>
                        <el-popover
                            popper-class="treePopoverClass"
                            placement="bottom"
                            width="570"
                            trigger="click"
                            v-model="popoverVisible">
                            <el-tree
                                class="parentIdTree"
                                ref="parentIdTree"
                                node-key="id"
                                :data="mainLists"
                                :props="authorityDefaultProps"
                                :expand-on-click-node="false"
                                :current-node-key="menuForm.pid"
                                highlight-current
                                default-expand-all
                                @node-click="handleNodeClick">
                            </el-tree>
                            <el-button slot="reference" class="parent-id-btn" ref="parent-id-btn">{{menuForm.parent_title}}</el-button>
                        </el-popover>
                    </el-form-item>
                </template>
                <el-form-item prop='sort' label='菜单排序'>
                    <el-input  v-model="menuForm.sort" placeholder='数值越大越靠前' clearable></el-input>
                </el-form-item>
                <el-form-item prop='icon' label='菜单图标'>
                    <el-input  v-model="menuForm.icon" placeholder='请输入菜单图标' clearable></el-input>
                </el-form-item>
                <el-form-item prop='status' label='状态'>
                    <el-switch
                        v-model="menuForm.status"
                        active-color="#409EFF"
                        active-value="active"
                        inactive-value="unactive">
                    </el-switch>
                </el-form-item>
            </el-form>
            <template slot="footer">
                <el-button type="primary" size="medium" @click="handleSave">保存</el-button>
            </template>
        </el-dialog>
    </div>
</template>
<script>
    import {menuList,menuCreate,menuUpdate,menuDelete} from '@/utils/getData';

    export default{
        name:'menu',
        data(){
            return{
                searchForm:{},
                defaultProps: {
                    label: 'title'
                },
                currentIndex:0,//当前新增或编辑的子菜单索引
                mainLists:[],
                menuForm:{
                    title:'',//菜单名称
                    code:'',//菜单类型
                    pid:'0',//父节点
                    url:'',//子菜单url
                    sort:'0',//排序
                    status:"active"
                },
                popoverVisible:false,
                authorityDefaultProps:{
                    label:'title',
                    children:'children'
                },
                formItemRules:{
                    type:[
                        {  required: true, message: '请选择侧边栏类型', trigger: 'change' }
                    ],
                    title: [
                        {  required: true, message: '请输入菜单名称', trigger: 'blur' }
                    ],
                    code: [
                        {  required: true, message: '请输入菜单类型', trigger: 'blur' }
                    ],
                    pid: [
                        {  required: true, message: '请选择父节点', trigger: 'change' }
                    ],
                    url: [
                        {  required: true, message: '请输入子菜单路径', trigger: 'blur' }
                    ]
                },
                showMenuDialogVisible:false,
            }
        },
        mounted(){
            this.init();
        },
        methods:{
            async init(){
                try {
                    let res = await menuList();
                    if (res.code == 0) {
                        this.mainLists = res.data;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.message,
                            type: 'error'
                        });
                    }
                } catch(e) {
                    this.$message({
                        showClose:true,
                        message: e.message,
                        type: 'error'
                    });
                }
            },
            handleInsert(currnetRow){//新增菜单
                try{
                    this.menuForm = Object.assign({},{status:'active',sort:'100'});
                    if(currnetRow.id){
                        this.menuForm.parent_title = currnetRow.title;
                        this.menuForm.pid = currnetRow.id;
                    }else{
                        this.menuForm.pid = '0';
                        this.menuForm.type = '1';
                    }
                    this.showMenuDialogVisible = true;
                }catch (e) {
                    this.$message({
                        showClose:true,
                        message: e.message,
                        type: 'error'
                    });
                }
            },
            handleEdit(currentRow){//编辑父菜单
                this.menuForm = JSON.parse(JSON.stringify(currentRow));
                this.menuForm.parent_title = currentRow.parent_title ? currentRow.parent_title : '';
                this.showMenuDialogVisible = true;
            },
            handleNodeClick(data){//选择父节点
                try {
                    this.menuForm.pid = data.id;
                    this.menuForm.parent_title = data.title;
                    this.$refs['parent-id-btn'].$el.innerText = data.title;
                    this.popoverVisible = false;
                }catch (e) {
                    this.$message({
                        showClose:true,
                        message: e.message,
                        type: 'error'
                    });
                }
            },
            handleDelete(currentRow){//删除
                this.$confirm('确定要删除吗', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async () => {
                    const res = await menuDelete({id:currentRow.id});
                    if (res.code == 0) {
                        this.mainLists = res.data;
                        this.$message({
                            showClose: true,
                            message: res.message,
                            type: 'success'
                        });
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.message,
                            type: 'error'
                        });
                    }
                }).catch((e) => {
                    if(e == 'cancel'){
                        return false;
                    }
                    this.$message({
                        showClose:true,
                        message: e.message,
                        type: 'error'
                    });
                });
            },
            handleReset(){//重置表单
                this.popoverVisible = false;
                this.$refs['menuForm'].resetFields();//重置表单数据
            },
            handleSave(){//保存
                this.$refs['menuForm'].validate(async (valid) => {
                    try{
                        if(valid){
                            let res = {},formData = this.menuForm;
                            if(formData.id){//编辑
                                res = await menuUpdate(formData);
                            }else{//新增
                                res = await menuCreate(formData);
                            }
                            if (res.code == 0) {
                                this.mainLists = res.data;
                                this.showMenuDialogVisible = false;
                            } else {
                                this.$message({
                                    showClose: true,
                                    message: res.message,
                                    type: 'error'
                                });
                            }
                        }
                    }catch (e) {
                        this.$message({
                            showClose: true,
                            message: e.message,
                            type: 'error'
                        });
                    }
                });
            }
        }
    }
</script>
<style scoped>
    .parent-id-btn{width: 100%;text-align: left;background: #fff;}
    .parentIdTree >>> .el-tree-node.is-current>.el-tree-node__content{color: #1876ef;}
    .treePopoverClass{height: 300px;overflow: auto;}
</style>